const AbstractCloverRequestRecord = require('./AbstractCloverRequestRecord');

class CloverDeviceListRequestRecord extends AbstractCloverRequestRecord {
    /**
     * @param {string} merchantID // A uuid.
     */
    constructor(merchantID) {
        if (!merchantID || merchantID.trim() === '') {
            throw new Error('merchantID is required');
        }
        // @link https://docs.clover.com/reference/devicegetmerchantdevices
        const url = '/v3/merchants/' + merchantID + '/devices';
        super(
            'GET',
            url
        );
    }
}

module.exports = CloverDeviceListRequestRecord;
